import { renameKeys } from "./general";

const KEY_MAP = {
  passport: '_psp',
  nationality: '_nty',
  firstName: '_fnm',
  lastName: '_lnm',
  sex: '_sx',
  dateOfBirth: '_dbr',
  countryOfBirth: '_cbr',
  number: '_nmr',
  dateOfIssue: '_dis',
  dateOfExpiry: '_dex',
  placeOfIssue: '_pis',
  idNumber: '_idn',
  address: '_adr'
};

export function renamePii<T extends object>(obj: T) {
  return renameKeys(obj, KEY_MAP, 'forward');
}

export function restorePii<T extends object>(obj: T) {
  return renameKeys(obj, KEY_MAP, 'reverse');
}